document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ec-home]').forEach((root) => {
    const stage = root.querySelector('.ec-home__stage');
    const nodes = [...root.querySelectorAll('[data-ec-node]')];
    const cards = [...root.querySelectorAll('[data-ec-card]')];
    const needButtons = [...root.querySelectorAll('[data-ec-need]')];
    const mini = root.querySelector('[data-ec-mini]');
    const miniTitle = root.querySelector('[data-ec-mini-title]');
    const miniDesc = root.querySelector('[data-ec-mini-desc]');
    const miniStatus = root.querySelector('[data-ec-mini-status]');
    const miniLink = root.querySelector('[data-ec-mini-link]');
    const miniClose = root.querySelector('[data-ec-mini-close]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let selected = null;
    let resizeFrame = null;

    const layoutNodes = () => {
      if (!stage) return;

      /*
       * 0.2.83 STABLE ORBIT:
       * desktop/iPad node coordinates are owned exclusively by CSS.
       * Keep the approved mobile <=620px layout exactly as before.
       */
      if (window.innerWidth > 620) return;

      const mobilePositions = {
        'ECCOMI POSTA': [50, 9],
        'ECCOMI SPEDIZIONI': [17, 34],
        'ECCOMI ENERGIA': [83, 34],
        'ECCOMI PERFORMANCE': [18, 72],
        'ECCOMI NOLEGGIO': [82, 72]
      };

      nodes.forEach((node, index) => {
        if (node.dataset.status === 'coming_soon') return;
        const position = mobilePositions[node.dataset.name] || [50, 50];
        node.style.left = `${position[0]}%`;
        node.style.top = `${position[1]}%`;
        if (!reducedMotion) node.style.animationDelay = `${0.2 + index * 0.05}s`;
      });
    };

    const requestLayout = () => {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(layoutNodes);
    };

    requestLayout();
    window.addEventListener('resize', requestLayout, { passive: true });
    requestAnimationFrame(() => root.classList.add('is-ready'));

    const normalizeNeeds = (el) => (el.dataset.needs || '').split(',').map((value) => value.trim().toLowerCase()).filter(Boolean);
    const applyNeed = (key) => {
      needButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.ecNeed === key));
      [...nodes, ...cards].forEach((el) => {
        const relevant = key === 'all' || normalizeNeeds(el).includes(key);
        el.classList.toggle('is-dimmed', !relevant);
      });
    };
    needButtons.forEach((button) => button.addEventListener('click', () => applyNeed(button.dataset.ecNeed || 'all')));

    const showMini = (node) => {
      if (!mini) return;
      nodes.forEach((item) => item.classList.toggle('is-selected', item === node));
      selected = node;
      if (miniTitle) miniTitle.textContent = node.dataset.name || 'ECCOMI';
      if (miniDesc) miniDesc.textContent = node.dataset.description || '';
      const comingSoon = node.dataset.status === 'coming_soon';
      if (miniStatus) miniStatus.textContent = comingSoon ? 'STIAMO PER ARRIVARE, RITORNA PRESTO!!!' : '';
      if (miniLink) {
        miniLink.href = node.dataset.url || '#';
        miniLink.textContent = comingSoon ? 'SCOPRI' : 'ENTRA';
      }
      mini.hidden = false;
      root.classList.add('is-mini-open');
    };

    const closeMini = () => {
      if (!mini) return;
      mini.hidden = true;
      root.classList.remove('is-mini-open');
      nodes.forEach((item) => item.classList.remove('is-selected'));
      selected = null;
    };

    nodes.forEach((node) => {
      node.addEventListener('click', () => {
        if (selected === node && mini && !mini.hidden) {
          const url = node.dataset.url;
          if (url && url !== '#') window.location.assign(url);
          return;
        }
        showMini(node);
      });
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) node.addEventListener('mouseenter', () => showMini(node));
    });

    miniClose?.addEventListener('click', closeMini);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mini && !mini.hidden) closeMini();
    });
  });
});